import {
	IconGripDotsVerticalOutline18 as GripIcon,
	IconSortNumAscendingOutline18 as LeastImportantIcon,
	IconSortTopToBottomOutline18 as LinearOrderIcon,
	IconSortBottomToTopOutline18 as LinearReversedIcon,
	IconSortNumDescendingOutline18 as MostImportantIcon,
} from "nucleo-ui-outline-18"

import type { RoadmapSortOrder } from "@productlane/zero/queries"

// Plain strings: Vite's pre-bundled Prisma enum can lag a `prisma generate`.
export const ROADMAP_SORT_OPTIONS: ReadonlyArray<{
	value: RoadmapSortOrder
	label: string
	Icon: typeof GripIcon
}> = [
	{ value: "CUSTOM", label: "Custom", Icon: GripIcon },
	{
		value: "SCORE_DESC",
		label: "Most important",
		Icon: MostImportantIcon,
	},
	{
		value: "SCORE_ASC",
		label: "Least important",
		Icon: LeastImportantIcon,
	},
	{
		value: "LINEAR",
		label: "Linear order",
		Icon: LinearOrderIcon,
	},
	{
		value: "LINEAR_REVERSE",
		label: "Linear reversed",
		Icon: LinearReversedIcon,
	},
]
